<app-print-layout-matDialog (imprimir)="onImprimir()" (fechar)="onFechar()" [retrato]="true" titulo="Impressão Folha Teste">

    <div class="card-body">

        <!-- ✅ Marca d'água exibida apenas quando cancelado for true -->
        <div *ngIf="cancelado" class="watermark">CANCELADA</div>

        <div>
            <div class="row mb-1">
                <div class="col-md-12" style="font-weight: bold; font-size: 18pt; text-align: center;">
                    FOLHA TESTE AMOSTRA - {{model.amostra?.nome}}
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-md-12">
                    <div>Nº da Ordem de Serviço de Execução: {{numeroOsa}}</div>
                    <div>Unidade Auditada: {{model.unidadeGestora?.nome}}</div>
                    <div>Nº da Folha Teste: {{model?.numeroFolha}}</div>
                    <div>Identificação da amostra: {{model.amostra?.nome}}</div>
                    <div>Identificação do nº do item da amostra: {{model?.amostraItemDescricao}}</div>
                    <div>Auditor Responsável: {{model?.nomeResponsavelFinalizado}} </div>
                    <div>Data de Preenchimento: {{ model?.dataFinalizado | date:'dd/MM/yyyy' }}</div>
                </div>
                <div class="col-md-12" style="padding-top: 15px;">
                    <table class="table" style="border: 1px solid #ccc; border-collapse: collapse; width: auto;">
                        <thead>
                            <tr>
                                <th colspan="2" style="width: 460px; text-align: center; border: 1px solid #ccc;">
                                    Procedimento / Teste
                                </th>
                                <th style="width: 300px; text-align: center; border: 1px solid #ccc;">
                                    Critério aplicável
                                </th>
                                <th style="width: 130px; text-align: center; border: 1px solid #ccc;">
                                    Avaliação
                                </th>
                                <th style="width: 130px; text-align: center; border: 1px solid #ccc;">
                                    Evidências
                                </th>
                                <th style="width: 130px; text-align: center; border: 1px solid #ccc;">
                                    Observações
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of model.questoes">
                                <td style="width: 60px; border: 1px solid #ccc; vertical-align: middle;">{{
                                    item.identificador }}</td>
                                <td style="width: 400px; border: 1px solid #ccc; vertical-align: middle;">{{
                                    item.procedimentoAuditoria ? item.procedimentoAuditoria?.nome : item.questao?.nome
                                    }}</td>
                                <td style="width: 300px; border: 1px solid #ccc;"
                                    [innerHTML]="item.questao?.legislacaoAplicavelCriterio"></td>
                                <td style="width: 130px; border: 1px solid #ccc;">{{item.avaliacaoDesc}}</td>
                                <td style="width: 300px; border: 1px solid #ccc;"
                                    [innerHTML]="getEvidencias(item.evidencias)"></td>
                                <td style="width: 130px; border: 1px solid #ccc;">{{item.observacao}}</td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    </div>

</app-print-layout-matDialog>